import { cuartosFriosProcess } from "@/mocks/serviceCuartosFriosData";

export default function CuartosFriosProcess() {
  return (
    <section className="py-12 md:py-20 px-4 md:px-8 lg:px-12 bg-background-100">
      <div className="max-w-6xl mx-auto">
        <div className="reveal text-center max-w-2xl mx-auto mb-12 md:mb-16">
          <span className="text-xs font-semibold tracking-[0.2em] uppercase text-[#0087a4] mb-3 block">
            Proceso de trabajo
          </span>
          <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-950 mb-4">
            Del diagnóstico al mantenimiento continuo
          </h2>
          <p className="text-foreground-600 text-sm md:text-base leading-relaxed">
            Un proceso estructurado que garantiza cuartos fríos correctamente diseñados, instalados y
            preparados para un rendimiento continuo.
          </p>
        </div>

        <div className="relative grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-8 md:gap-6">
          <div className="hidden lg:block absolute top-8 left-[10%] right-[10%] h-px bg-[#0087a4]/25" />

          {cuartosFriosProcess.map((step, i) => (
            <div
              key={step.step}
              className="reveal relative text-center"
              style={{ transitionDelay: `${i * 100}ms` }}
            >
              <div className="relative z-10 inline-flex w-16 h-16 rounded-full bg-background-50 border-2 border-[#0087a4]/30 text-[#0087a4] items-center justify-center font-heading font-bold text-lg mb-4">
                {step.step}
              </div>
              <h3 className="font-heading font-bold text-foreground-950 text-sm md:text-base mb-2">
                {step.title}
              </h3>
              <p className="text-foreground-600 text-sm leading-relaxed">{step.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}